import { v4 as uuidv4 } from "uuid";

export const WEB_APP_CHANNEL = "Web";

const DEVICE_ID_STORAGE_KEY = "banklingo_web_device_id";
const DEVICE_ID_COOKIE_NAME = "banklingo_web_device_id";
const DEVICE_ID_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

let cachedDeviceId = null;

const readDeviceIdCookie = () => {
  if (typeof document === "undefined") return null;

  const prefix = `${DEVICE_ID_COOKIE_NAME}=`;
  const cookie = document.cookie
    .split(";")
    .map((value) => value.trim())
    .find((value) => value.startsWith(prefix));

  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : null;
};

const persistDeviceId = (deviceId) => {
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
    } catch (_) {
      // Storage can be unavailable in privacy-restricted browser contexts.
    }
  }

  if (typeof document !== "undefined") {
    const secure =
      typeof window !== "undefined" && window.location?.protocol === "https:"
        ? "; Secure"
        : "";
    document.cookie = `${DEVICE_ID_COOKIE_NAME}=${encodeURIComponent(
      deviceId
    )}; Max-Age=${DEVICE_ID_COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
  }
};

export const getWebDeviceId = () => {
  if (cachedDeviceId) return cachedDeviceId;

  let storedDeviceId = null;
  if (typeof window !== "undefined") {
    try {
      storedDeviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    } catch (_) {
      // Fall through to the cookie or a newly generated identifier.
    }
  }

  cachedDeviceId = storedDeviceId || readDeviceIdCookie() || uuidv4();
  persistDeviceId(cachedDeviceId);
  return cachedDeviceId;
};

export const getBackendClientHeaders = () => ({
  "X-App-Channel": WEB_APP_CHANNEL,
  "X-Device-Id": getWebDeviceId(),
});
